<app-modal-wrapper
  [textHeader]="'UI.Modal.Inform'"
  textOk="Yes"
  (btnOkClicked)="activeModal.close(true)"
  (btnCancelClicked)="activeModal.close(false)"
>
  {{ 'UI.Modal.SubmitVentureInformContent' | translate }}
</app-modal-wrapper>
